module.exports = __webpack_public_path__ + "static/img/r-2.fc29c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/r-2.png
// module id = k8Uc
// module chunks = 0